// extracted by mini-css-extract-plugin
export default {"policy_container":"Policy_policy_container__UyJ0W","policy_content":"Policy_policy_content__emcwE"};